import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getGeoValueByType } from '../../../packages/JsonQuery';
import { IJsonQueryUnderground } from '../../../packages/api-models/common/json_query';

export const selectUndergroundStations = createSelector(selectJsonQuery, jsonQuery => {
  const geo = getGeoValueByType<IJsonQueryUnderground>('underground')(jsonQuery);

  return geo ? geo.map(({ id }) => id) : [];
});
